import type { FaireProductEntity } from "../../entity_types/product";

export const p_z84dk4gk7g: FaireProductEntity = {
  token: "p_z84dk4gk7g",
  type: "product",
  name: "Buddha Statue for Meditation - Meditating Buddha Figurine",
  brandToken: "b_qqbr958t4u",
  brandName: "My Wholesale Gifts",
  imageUrl: "https://cdn.faire.com/fastly/b0d61a6e87cc7030db41facde0a6e2cf05f784a9a8a900de6a235fa7870472f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e2577f2dc67dcbe1a67c0dba739c0859034da26e40906b4f83259dcbe4a6b9cb.jpeg"
  ],
  priceDollars: 65.65,
  description: "Enhance your meditation practice with a stunning Buddha statue. This intricately designed meditating Buddha statue is perfect for creating a peaceful and serene atmosphere in your meditation space. Crafted from high-quality materials, this statue features exquisite detailing and a calming presence. Add this beautiful piece to your meditation altar or sacred space to inspire mindfulness and tranquility during your practice.\n• This statue weighs 3.6 lbs. And measures 8.5 inches by 7 inches by 11.5 inches.\n• Made of durable fiberglass to create a beautifully detailed sculpture.\n• Bring joy and prosperity into your home with this lovely statue! Perfect for a meditation room or as shelf d&eacute;cor, this statue exudes happiness and luck into any space you decide to display it.\n• To clean your statue, dust lightly or wipe with a damp cloth as needed\n• Decorate your home with a touch of peace, tranquility and Zen! This intricately designed Buddha statue captures him in deep meditation and has a calming influence on any room. The stone-like finish makes him look like a worldly treasure!",
  tags: [],
  msrpDollars: 101.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:14.837Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
